import { render, staticRenderFns } from "./UserLogoutTimer.vue?vue&type=template&id=b2ca030a&"
import script from "./UserLogoutTimer.vue?vue&type=script&lang=js&"
export * from "./UserLogoutTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports